import type React from "react";

interface EqualizerIconProps {
  className?: string;
}

export const EqualizerIcon: React.FC<EqualizerIconProps> = ({ className }) => (
  <svg
    className={className}
    width="9"
    height="9"
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="2.37891"
      width="1.05731"
      height="3.70057"
      rx="0.528653"
      fill="currentColor"
    />
    <rect
      x="1.98535"
      width="1.05731"
      height="8.45845"
      rx="0.528653"
      fill="currentColor"
    />
    <rect
      x="3.97168"
      y="2.11426"
      width="1.05731"
      height="4.22923"
      rx="0.528653"
      fill="currentColor"
    />
    <rect
      x="5.95703"
      y="1.05762"
      width="1.05731"
      height="6.34384"
      rx="0.528653"
      fill="currentColor"
    />
    <rect
      x="7.94238"
      y="2.90723"
      width="1.05731"
      height="2.64327"
      rx="0.528653"
      fill="currentColor"
    />
  </svg>
);
